import { Field, FieldProps, Formik, FormikProps } from "formik";
import React, { forwardRef, useImperativeHandle, useRef } from "react";
import { Form } from "react-bootstrap";
import { StyledInput } from "../../../../components/inputs/styledInput";
import { useTranslation } from "react-i18next";
import { InputPassword } from "../../../../components/inputs/password";
import { PagePasswordRequest } from "../../types";
import { PageQueryHookResult } from "../../../../graphql/page.hooks";

type Props = {
  isActive: boolean;
  passwordRestriction: PageQueryHookResult["data"]["page"]["pageRestriction"];
};

export type PagePasswordFormRef = {
  getFormValues: () => PagePasswordRequest;
  submit: () => void;
};

export const PagePasswordForm = forwardRef<PagePasswordFormRef, Props>(
  ({ passwordRestriction, isActive }, ref) => {
    const { t } = useTranslation();

    const initialValues: PagePasswordRequest = {
      checkboxPassword: passwordRestriction?.checkboxPassword ? 1 : 0,
      password: passwordRestriction?.password || "",
      passwordHint: passwordRestriction?.passwordHint || "",
    };

    const formikRef = useRef<FormikProps<typeof initialValues>>(null);

    useImperativeHandle(ref, () => ({
      getFormValues: () => {
        const currentValues = formikRef.current?.values || initialValues;
        return { ...currentValues, checkboxPassword: isActive ? 1 : 0 };
      },
      submit: () => formikRef.current?.handleSubmit(),
    }));

    if (!isActive) {
      return <></>;
    }

    return (
      <div className="mb-4">
        <Formik
          innerRef={formikRef}
          initialValues={initialValues}
          enableReinitialize
          onSubmit={() => {}}
        >
          {({ handleSubmit, touched, errors }) => (
            <Form onSubmit={handleSubmit}>
              <div className="col-12 d-flex flex-wrap gap-md-3">
                <div className="col-12 col-md-5 flex-grow-1">
                  <Field name="password">
                    {({ field, meta, form }: FieldProps) => (
                      <InputPassword
                        label={t("profile.password")}
                        placeholder={t("profile.password")}
                        id="password"
                        field={field}
                        meta={meta}
                        form={form}
                      />
                    )}
                  </Field>
                </div>
                <div className="form-floating col-12 col-md-5 flex-grow-1">
                  <StyledInput
                    name="passwordHint"
                    className="text-dark-gray"
                    label={t("page.Hint Text")}
                    error={!!(touched.passwordHint && errors.passwordHint)}
                  />
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    );
  }
);

PagePasswordForm.displayName = "PagePasswordForm";
